module.exports = __webpack_public_path__ + "bigboss_icon-731c73f00b2c72960b27.svg";